/* Crown Ness — liste de favoris (étoile). Stockage dans le navigateur (localStorage), sans compte client. */
(() => {
  if (window.__cnWishlist) return;
  window.__cnWishlist = true;

  const KEY = 'cn_wishlist';
  const en = (document.documentElement.lang || 'fr').toLowerCase().startsWith('en');
  const L = en
    ? { add: 'Add to favorites', remove: 'Remove from favorites', pdpAdd: 'Add to my favorites', pdpSaved: 'In my favorites' }
    : { add: 'Ajouter aux favoris', remove: 'Retirer des favoris', pdpAdd: 'Ajouter à mes favoris', pdpSaved: 'Dans mes favoris' };

  const STAR =
    '<svg class="cn-star" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
    '<path d="M12 3.3l2.6 5.5 6 .8-4.4 4.2 1.1 6-5.3-2.9-5.3 2.9 1.1-6L3.4 9.6l6-.8z"/></svg>';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let memory = null;

  const read = () => {
    if (memory) return memory.slice();
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
    } catch (e) {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
      memory = null;
    } catch (e) {
      memory = list.slice();
    }
  };

  const has = (handle) => read().includes(handle);

  const handleFrom = (href) => {
    const m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  };

  const sync = () => {
    const list = read();
    document.querySelectorAll('[data-cn-handle]').forEach((btn) => {
      const active = list.includes(btn.dataset.cnHandle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (btn.classList.contains('cn-fav--pdp')) {
        btn.querySelector('.cn-fav__label').textContent = active ? L.pdpSaved : L.pdpAdd;
      } else {
        btn.setAttribute('aria-label', active ? L.remove : L.add);
      }
    });
    document.querySelectorAll('.cn-wishlist-count').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    document.dispatchEvent(new CustomEvent('cn:wishlist'));
  };

  const toggle = (handle) => {
    const list = read();
    const i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1);
    else list.push(handle);
    write(list);
    sync();
  };

  const makeButton = (handle, extraClass, withLabel) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cn-fav ' + extraClass;
    btn.dataset.cnHandle = handle;
    btn.innerHTML = STAR + (withLabel ? '<span class="cn-fav__label"></span>' : '');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggle(handle);
    });
    return btn;
  };

  const scan = () => {
    document.querySelectorAll('product-card:not([data-cn-fav])').forEach((card) => {
      card.setAttribute('data-cn-fav', '');
      const link = card.querySelector('a[href*="/products/"]');
      const gallery = card.querySelector('.card-gallery');
      const handle = handleFrom(link && link.getAttribute('href'));
      if (!handle || !gallery) return;
      gallery.appendChild(makeButton(handle, 'cn-fav--card', false));
    });

    const drawerList = document.querySelector('.menu-drawer__menu.has-submenu');
    if (drawerList && !drawerList.querySelector('.cn-drawer-fav')) {
      const item = document.createElement('li');
      item.className = 'menu-drawer__list-item--flat cn-drawer-fav';
      item.style.setProperty('--menu-drawer-animation-index', '7');
      const link = document.createElement('a');
      link.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset';
      link.href = (root + 'pages/favoris').replace('//', '/');
      const label = document.createElement('span');
      label.className = 'menu-drawer__menu-item-text wrap-text';
      label.textContent = en ? 'My favorites' : 'Mes favoris';
      link.appendChild(label);
      item.appendChild(link);
      const account = [...drawerList.children].find((li) => li.querySelector('a[href$="/account"]'));
      drawerList.insertBefore(item, account || null);
    }

    const handle = handleFrom(location.pathname);
    const block = document.querySelector('.buy-buttons-block');
    if (handle && block && !document.querySelector('.cn-fav--pdp')) {
      block.insertAdjacentElement('afterend', makeButton(handle, 'cn-fav--pdp', true));
    }
    sync();
  };

  /* Page « Favoris » */
  const cache = {};

  const load = async (handle) => {
    if (cache[handle] !== undefined) return cache[handle];
    try {
      const r = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
      cache[handle] = r.ok ? await r.json() : null;
    } catch (e) {
      cache[handle] = null;
    }
    return cache[handle];
  };

  const money = (cents) =>
    new Intl.NumberFormat(en ? 'en-IE' : 'fr-FR', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(cents / 100);

  const renderPage = async () => {
    const grid = document.querySelector('[data-cn-wishlist-grid]');
    if (!grid) return;
    const empty = document.querySelector('[data-cn-wishlist-empty]');
    const list = read();
    const products = (await Promise.all(list.map(load))).filter(Boolean);
    grid.textContent = '';
    products.forEach((p) => {
      const card = document.createElement('article');
      card.className = 'cn-fav-card';

      const media = document.createElement('a');
      media.className = 'cn-fav-card__media';
      media.href = p.url;
      if (p.featured_image) {
        const img = document.createElement('img');
        img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=700';
        img.alt = p.title;
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const name = document.createElement('a');
      name.className = 'cn-fav-card__name';
      name.href = p.url;
      name.textContent = p.title;

      const price = document.createElement('span');
      price.className = 'cn-fav-card__price';
      price.textContent = money(p.price);

      card.append(media, makeButton(p.handle, 'cn-fav--card', false), name, price);
      grid.appendChild(card);
    });
    if (empty) empty.hidden = products.length > 0;
    sync();
  };

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  document.addEventListener('cn:wishlist', () => {
    if (document.querySelector('[data-cn-wishlist-grid]')) {
      const grid = document.querySelector('[data-cn-wishlist-grid]');
      const shown = [...grid.querySelectorAll('[data-cn-handle]')].map((b) => b.dataset.cnHandle);
      const now = read();
      if (shown.length !== now.length || shown.some((h) => !now.includes(h))) renderPage();
    }
  });

  window.addEventListener('storage', (e) => {
    if (e.key === KEY) {
      sync();
      renderPage();
    }
  });

  const start = () => {
    scan();
    renderPage();
    new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
